import { render, staticRenderFns } from "./CField.vue?vue&type=template&id=61498294&"
import script from "./CField.vue?vue&type=script&lang=js&"
export * from "./CField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports